import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { AppleBusinessChatEvents, } from './AppleBusinessChatSegmentEvent';
export class AppleBusinessChatSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackAppleBusinessChatRegisterLinkClicked(payload, success) {
        this.trackEvent(AppleBusinessChatEvents.CHANNEL_CONNECTION_APPLEBUSINESSCHAT_LINK, payload, success);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
AppleBusinessChatSegmentService.$inject = ['SegmentService'];
